import React from 'react';
import { Image, Link, Placeholder } from '@sitecore-jss/sitecore-jss-react';

const InterstitialHeader = ({ rendering, fields }) => {
  return (
    <div className="vds-interstitial-page">
      <div className="vds-interstitial-page__inner">
        <header className="vds-interstitial-page__header">
          <div className="vds-interstitial-page__header-logo-container">
            <Link className="vds-interstitial-page__header-logo-link" field={fields.link}>
              <Image className="vds-interstitial-page__header-logo" field={fields.image} />
            </Link>
          </div>
        </header>
        <main className="vds-interstitial-page__main">
          <Placeholder name="interstitial-content" rendering={rendering} />
        </main>
      </div>
    </div>
  );
};

export default InterstitialHeader;
